import { Button, Checkbox, Input, message, Modal } from "antd";
import moment from "moment";
import { useEffect, useState } from "react";
import { apis } from "../../config/APIs";
import useAxios from "../../config/useAxios";
import SearchInput from "../Common/SearchInput"; // Correct path
import InfiniteTable from "./InfiniteTable";
import { useDispatch, useSelector } from "react-redux";
import { corporateBudget } from "../../actions/cards/cards";

const InfiniteTransfersSection = ({
  bulkId,
  onBack,
  hasAccessToWrite,
  savedDeselected = [],
  onUpdateDeselected,
}) => {
  const dispatch = useDispatch();

  // State
  const [selectedRecords, setSelectedRecords] = useState([]);
  const [deselectedRecords, setDeselectedRecords] = useState(savedDeselected);
  //   const [totalDeselectedRecords, setTotalDeselectedRecords] = useState(0);
  const [totalLoadedAmount, setTotalLoadedAmount] = useState(0);
  const [totalDeselectedAmount, setTotalDeselectedAmount] = useState(0);

  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const [loading, setLoading] = useState(false);
  const [isApproveConfirm, setIsApproveConfirm] = useState(false);
  const [isRejectConfirm, setIsRejectConfirm] = useState(false);
  const [rejectReason, setRejectReason] = useState("");
  const [searchValue, setSearchValue] = useState(""); // Search State

  // Pagination state for deselected records (getPendingRecords)
  const [deselectedPage, setDeselectedPage] = useState(1);
  const [deselectedHasMore, setDeselectedHasMore] = useState(true);
  const [deselectedLoading, setDeselectedLoading] = useState(false);
  const [activeTab, setActiveTab] = useState("selected"); // Tab state
  const [approvalAmount, setApprovalAmount] = useState(0);
  const [isApproveInitiated, setIsApproveInitiated] = useState(false);

  const MIN_VISIBLE_ROWS = 6;

  const currentData =
    activeTab === "selected" ? selectedRecords : deselectedRecords;

  const isAllSelected =
    currentData.length > 0 &&
    currentData.every((row) =>
      activeTab === "selected"
        ? !deselectedRecords.find((d) => d.id === row.id)
        : true,
    );

  const handleSelectAll = (e) => {
    e.stopPropagation();

    if (activeTab === "selected") {
      // Move ALL selected rows → deselected
      currentData.forEach((record) => {
        handleSelectRow(null, record);
      });
    } else {
      // Move ALL deselected rows → selected
      currentData.forEach((record) => {
        handleDeselectRow(null, record);
      });
    }
  };

  // API Hook for fetching data (Pagination)
  const {
    onCall: fetchDataCall,
    data: fetchResponse,
    loading: fetchLoading,
    reset: fetchReset,
  } = useAxios({
    api: apis.transfersBlukShow,
    method: "get",
    showSuccessMessage: false,
  });

  // API Hook for Approve
  const {
    onCall: approveCall,
    data: approveRes,
    loading: approveLoad,
    reset: approveResReset,
  } = useAxios({
    api: "/api/admin/cards/v1/bulkapprove",
    method: "post",
    showSuccessMessage: false,
  });

  // API Hook for Reject
  const {
    onCall: rejectCall,
    data: rejectRes,
    loading: rejectLoad,
    reset: rejectResReset,
  } = useAxios({ api: apis.transfersRejectV2, method: "post", showSuccessMessage: false, });

  // API Hook for Save Pending
  const {
    onCall: savePendingCall,
    data: savePendingRes,
    loading: savePendingLoading,
    reset: savePendingReset,
  } = useAxios({ api: apis.savePendingRecords, method: "post" });

  // API Hook for Get Pending
  const {
    onCall: getPendingCall,
    data: getPendingRes,
    loading: getPendingLoading,
  } = useAxios({
    api: apis.getPendingRecords,
    method: "get",
    showSuccessMessage: false,
  });

  // API Hook for Approval Amount
  const {
    onCall: fetchApprovalAmount,
    data: approvalAmountRes,
    loading: approvalAmountLoading,
  } = useAxios({
    api: "/api/staff/v1/bulkUploads/approvalAmount",
    method: "get",
    showSuccessMessage: false,
  });

  const backendTotal =
    fetchResponse?.response?.data?.total_no_of_cards ||
    fetchResponse?.total_records ||
    0;

  const corporate_budget = useSelector(
    (state) => state.cards.corporate_budget?.data?.response,
  );

  const uiDeselectedCount = deselectedRecords.length;

  const uiSelectedCount = Math.max(backendTotal - uiDeselectedCount, 0);

  useEffect(() => {
    if (corporate_budget?.currentLimit !== undefined) {
      console.log(
        "Corporate Budget AFTER approval (latest):",
        corporate_budget.currentLimit,
      );
    }
  }, [corporate_budget]);

  // Initial Fetch: Get Pending Records & Main Records
  useEffect(() => {
    // Reset Deselected State on new Bulk ID
    setDeselectedRecords([]);
    setDeselectedPage(1);
    setDeselectedHasMore(true);
    // setTotalDeselectedRecords(0);
    setTotalDeselectedAmount(0);

    // Fetch Pending Records first (or parallel)
    if (bulkId) {
      fetchPendingRecords(1);
    }
    fetchRecords(1);
  }, [bulkId]);

  // Fetch Pending Records with pagination
  const fetchPendingRecords = (pageNum) => {
    setDeselectedLoading(true);
    getPendingCall({ params: { bulk_upload_id: bulkId, page: pageNum } });
  };

  // Handle Get Pending Response
  useEffect(() => {
    if (getPendingRes) {
      const responseData = getPendingRes;
      const pendingData = responseData?.response?.data || [];

      if (responseData?.status && Array.isArray(pendingData)) {
        if (deselectedPage === 1) {
          // First page - replace all records
          setDeselectedRecords(pendingData);
        } else {
          // Subsequent pages - append unique records
          setDeselectedRecords((prev) => {
            const existingIds = new Set(prev.map((r) => r.id));
            const uniqueNew = pendingData.filter((r) => !existingIds.has(r.id));
            return [...prev, ...uniqueNew];
          });
        }

        // Check if there are more records to load
        if (pendingData.length === 0) {
          setDeselectedHasMore(false);
        }
      }
      //   const total =
      //     responseData?.total_records ||
      //     responseData?.response?.total_records ||
      //     0;
      //   setTotalDeselectedRecords(total);

      // Update Total Deselected Amount from response
      // User suggested usage of 'totalPendingAmount', checking possible fields
      const pendingAmount =
        responseData?.response?.totalPendingAmount ||
        responseData?.totalPendingAmount ||
        0;
      setTotalDeselectedAmount(pendingAmount);

      setDeselectedLoading(false);
    }
  }, [getPendingRes]);

  // Fetch more deselected records (infinite scroll)
  const fetchMoreDeselectedData = () => {
    if (!deselectedLoading && deselectedHasMore) {
      const nextPage = deselectedPage + 1;
      setDeselectedPage(nextPage);
      fetchPendingRecords(nextPage);
    }
  };

  // Ensure Selected Records excludes Deselected Records
  // (Crucial if GetPending returns AFTER selected records are loaded)
  useEffect(() => {
    if (deselectedRecords.length > 0 && selectedRecords.length > 0) {
      const deselectedIds = new Set(deselectedRecords.map((r) => r.id));

      // Check if any selected record is currently in deselected list
      const hasOverlap = selectedRecords.some((r) => deselectedIds.has(r.id));

      if (hasOverlap) {
        setSelectedRecords((prev) =>
          prev.filter((r) => !deselectedIds.has(r.id)),
        );
      }
    }
  }, [deselectedRecords]);

  // Helper for extracting API errors
  const getErrorMessage = (res) => {
    const responseData = res?.response?.data || res;
    let errorMsg = "";
    const errors = responseData?.errors;

    if (errors) {
      if (typeof errors === "string") {
        errorMsg = errors;
      } else if (Array.isArray(errors) && errors.length > 0) {
        const validErrors = errors.filter((e) => e);
        if (validErrors.length > 0) errorMsg = validErrors.join(", ");
      } else if (typeof errors === "object" && Object.keys(errors).length > 0) {
        errorMsg = JSON.stringify(errors);
      }
    }

    if (!errorMsg || errorMsg === "[]" || errorMsg === "{}") {
      errorMsg = responseData?.message;
    }

    return errorMsg || "Something went wrong";
  };

  // Initial Fetch & Page Increment Fetch
  const fetchRecords = (pageNum, searchVal = searchValue) => {
    setLoading(true);
    const params = {
      id: bulkId,
      page: pageNum,
    };
    if (searchVal) {
      params.search = searchVal;
    }
    fetchDataCall({ params });
  };

  // Sync deselected records to parent
  useEffect(() => {
    if (onUpdateDeselected) {
      onUpdateDeselected(deselectedRecords);
    }
  }, [deselectedRecords]);

  // Handle Fetch Response
  useEffect(() => {
    if (fetchResponse?.status && fetchResponse?.response?.data) {
      const newTopups = fetchResponse.response.data.topups || [];

      // Filter out records that are already in 'deselectedRecords'
      // Logic: "if it appears during the pagination api call it should be removed (from selected)"
      const deselectedIds = new Set(deselectedRecords.map((r) => r.id));
      const filteredNewTopups = newTopups.filter(
        (r) => !deselectedIds.has(r.id),
      );

      if (page === 1) {
        setSelectedRecords(filteredNewTopups);
        // Update Total Loaded Amount from the first page of response
        const totalAmount =
          fetchResponse?.response?.totalAmount ||
          fetchResponse?.totalAmount ||
          0;
        setTotalLoadedAmount(totalAmount);
      } else {
        setSelectedRecords((prev) => {
          const existingIds = new Set(prev.map((r) => r.id));
          const uniqueNew = filteredNewTopups.filter(
            (r) => !existingIds.has(r.id),
          );
          return [...prev, ...uniqueNew];
        });
      }

      const totalRecords =
        fetchResponse?.response?.total_records ||
        fetchResponse?.total_records ||
        0;

      const PAGE_SIZE = fetchResponse?.response?.page_size || 10;

      const loadedCount = page * PAGE_SIZE;

      setHasMore(loadedCount < totalRecords);

      setLoading(false);
    }
  }, [fetchResponse]);

  useEffect(() => {
    if (
      activeTab === "selected" &&
      selectedRecords.length < MIN_VISIBLE_ROWS &&
      hasMore &&
      !loading
    ) {
      const nextPage = page + 1;
      setPage(nextPage);
      fetchRecords(nextPage, searchValue);
    }
  }, [selectedRecords.length, hasMore, loading, activeTab]);

  // useEffect(() => {
  //   if (approvalAmountRes?.status) {
  //     const amount = approvalAmountRes?.response?.total_amount || 0;

  //     setApprovalAmount(amount);
  //   }
  // }, [approvalAmountRes]);

    useEffect(() => {
        if (!isApproveInitiated) return;

        if (approvalAmountRes?.status) {
            const approvalAmt = approvalAmountRes?.response?.total_amount || 0;
            setApprovalAmount(approvalAmt);

            // ✅ Always open modal
            setIsApproveConfirm(true);
        }
    }, [approvalAmountRes, isApproveInitiated]);

  const fetchMoreData = () => {
    if (!loading && hasMore) {
      const nextPage = page + 1;
      setPage(nextPage);
      fetchRecords(nextPage, searchValue); // Pass current search value
    }
  };

  // Search Handler
  const handleSearch = (val) => {
    setSearchValue(val);
    setPage(1);
    setHasMore(true);
    // Reset selected records on search change?
    // Yes, new search means new list.
    setSelectedRecords([]);
    fetchRecords(1, val);
  };

  // Move Logic
  const handleSelectRow = (e, record) => {
    e?.stopPropagation?.();
    // 1. Move from Selected to Deselected (Optimistic UI)
    setSelectedRecords((prev) => prev.filter((r) => r.id !== record.id));
    setDeselectedRecords((prev) => [...prev, record]);
    // setTotalDeselectedRecords((prev) => prev + 1);

    // 2. Call Save API
    savePendingCall({
      params: { bulk_upload_id: bulkId },
      data: { approval_ids: [record.id] },
    })
      .then((res) => {
        // Update total deselected amount from response
        const responseData = res?.response?.data || res;
        const pendingAmount =
          responseData?.totalPendingAmount ||
          responseData?.response?.totalPendingAmount;
        if (pendingAmount !== undefined) {
          setTotalDeselectedAmount(pendingAmount);
        }
      })
      .catch((err) => {
        console.error("Save Pending Failed", err);
        message.error("Failed to save pending record: " + getErrorMessage(err));
        // Revert on failure
        // setTotalDeselectedRecords((prev) => Math.max(0, prev - 1));
        setDeselectedRecords((prev) => prev.filter((r) => r.id !== record.id));
        setSelectedRecords((prev) => [...prev, record]);
      });
  };

  const handleDeselectRow = (e, record) => {
    e?.stopPropagation?.();
    // 1. Move from Deselected to Selected (Optimistic UI)
    setDeselectedRecords((prev) => prev.filter((r) => r.id !== record.id));
    setSelectedRecords((prev) => [...prev, record]);
    // setTotalDeselectedRecords((prev) => Math.max(0, prev - 1));

    // 2. Call Save API with delete=true
    savePendingCall({
      params: { bulk_upload_id: bulkId },
      data: { approval_ids: [record.id], delete: true },
    })
      .then((res) => {
        // Update total deselected amount from response
        const responseData = res?.response?.data || res;
        const pendingAmount =
          responseData?.totalPendingAmount ||
          responseData?.response?.totalPendingAmount;
        if (pendingAmount !== undefined) {
          setTotalDeselectedAmount(pendingAmount);
        }
      })
      .catch((err) => {
        console.error("Remove Pending Failed", err);
        message.error(
          "Failed to remove pending record: " + getErrorMessage(err),
        );
        // Revert
        // setTotalDeselectedRecords((prev) => prev + 1);
        setSelectedRecords((prev) => prev.filter((r) => r.id !== record.id));
        setDeselectedRecords((prev) => [...prev, record]);
      });
  };

  const handleApprove = () => {
    dispatch(corporateBudget());
    console.log(
      "Corporate Budget BEFORE approval:",
      corporate_budget?.currentLimit,
    );

    setIsApproveInitiated(true);
    fetchApprovalAmount({
      params: { bulk_upload_id: bulkId },
    });
  };

    const handleApproveConfirm = () => {
    console.log("=== handleApproveConfirm called ===");

    const approvalAmt = approvalAmount;
    const corporateLimit = corporate_budget?.currentLimit || 0;

    console.log("approvalAmt:", approvalAmt);
    console.log("corporateLimit:", corporateLimit);

    if (approvalAmt > corporateLimit) {
        console.log("Returned because approval amount exceeds limit");
        message.error(
            "Card Loading Balance exceeded. Your available Corporate Balance is less than Card Loading Amount"
        );
        return;
    }

    const deselectedIds = deselectedRecords.map((r) => r.id);

    console.log("Calling approve API...");
    console.log("bulkId:", bulkId);
    console.log("approval_ids:", deselectedIds);

    approveCall({
      params: {
        bulk_upload_id: bulkId,
      },
      data: {
        bulk_upload_id: bulkId,
        approval_ids: deselectedIds,
      },
    }).catch((err) => {
      console.error("Approval API Error:", err);
    });
  };
  useEffect(() => {
    console.log("approveRes:", approveRes);
    if (approveRes) {
      // Handle potential Axios Error Object (if request failed with 4xx/5xx)
      const responseData = approveRes.response?.data || approveRes;
      console.log("responseData:", responseData);
      console.log("responseData.message:", responseData?.message);
      console.log("responseData.response:", responseData?.response);

      if (responseData?.status) {
        message.success(responseData.message || "Approved successfully");
        
        setIsApproveConfirm(false);
        setIsApproveInitiated(false);
        dispatch(corporateBudget());
        // Post-approval: Reset to page 1 and refresh both lists
        setPage(1);
        setHasMore(true);
        setSelectedRecords([]);
        setDeselectedRecords([]);
        setDeselectedPage(1);
        setDeselectedHasMore(true);
        // setTotalDeselectedRecords(0);
        setTotalDeselectedAmount(0);
        // Fetch fresh data from page 1
        fetchRecords(1, searchValue);
        fetchPendingRecords(1);
      } else if (responseData?.status === false || responseData?.errors) {
        message.error(getErrorMessage(approveRes));
      }
    }
  }, [approveRes]);

  // Reject Logic
  const handleRejectConfirm = () => {
    if (!rejectReason || rejectReason.length < 1 || rejectReason.length > 100) {
      message.error("Reject reason must be between 10 and 100 characters.");
      return;
    }
    const isSelectedTab = activeTab === "selected";

    rejectCall({
      params: {
        bulk_upload_id: bulkId,
        selected: isSelectedTab,
        reject_reason: rejectReason.replace(/\n/g, " ").replace(/,/g, " "),
      },
    }).catch((err) => {
      console.error("Reject API Error:", err);
    });
  };

  useEffect(() => {
    if (rejectRes) {
      const responseData = rejectRes.response?.data || rejectRes;

      if (responseData?.status) {
        message.success(responseData.message || "Rejected successfully");
        setIsRejectConfirm(false);
        setDeselectedRecords([]);
        setSelectedRecords([]);
        // setTotalDeselectedRecords(0);
        setTotalDeselectedAmount(0);
        fetchRecords(1, searchValue);
        fetchPendingRecords(1);
      } else if (responseData?.status === false || responseData?.errors) {
        message.error(getErrorMessage(rejectRes));
      }
    }
  }, [rejectRes]);

  // Columns Definition
  const columns = [
    {
      title: (
        <Checkbox
          checked={currentData.length > 0}
          indeterminate={
            currentData.length > 0 &&
            currentData.length <
              (activeTab === "selected"
                ? selectedRecords.length
                : deselectedRecords.length)
          }
          onChange={handleSelectAll}
        />
      ),
      dataIndex: "checkbox",
      key: "checkbox",
      width: 50,
      render: (_, record) => (
        <Checkbox
          checked={true}
          onChange={(e) => {
            if (activeTab === "selected") {
              handleSelectRow(e.nativeEvent, record);
            } else {
              handleDeselectRow(e.nativeEvent, record);
            }
          }}
        />
      ),
    },

    {
      title: "Transaction Date & Time",
      dataIndex: "created_at",
      key: "created_at",
      render: (text) => <div>{moment(text).format("DD MMM'YY, HH:mm:ss")}</div>,
    },
    {
      title: "Employee ID",
      dataIndex: "card",
      key: "employee_id",
      render: (card) => <div>{card?.employee_details?.employee_id || "-"}</div>,
    },
    {
      title: "Employee Name",
      dataIndex: "card",
      key: "employee_name",
      render: (card) => <div>{card?.employee_details?.name || "-"}</div>,
    },
    {
      title: "Email",
      dataIndex: "card",
      key: "email",
      render: (card) => <div>{card?.employee_details?.email || "-"}</div>,
    },
    {
      title: "Mobile Number",
      dataIndex: "card",
      key: "mobile",
      render: (card) => <div>{card?.employee_details?.mobile || "-"}</div>,
    },
    {
      title: "Wallet Name",
      dataIndex: "list_of_wallets_and_topup_amount",
      key: "wallet_name",
      render: (text) => (
        <div>
          {(text || [])
            .map((textEle) => textEle?.walletKeyIdentifier || "")
            .filter(Boolean)
            .join(", ")}
        </div>
      ),
    },
    {
      title: "No...of Cards",
      dataIndex: "card_count",
      key: "card_count",
      render: (count) => <div>{count || 1}</div>,
    },
    {
      title: "Loaded Amount",
      dataIndex: "amount",
      key: "amount",
      render: (text) => <div>Rs. {text}</div>,
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      render: (text) => {
        const style =
          text === "In Progress"
            ? { backgroundColor: "#fef4de", color: "#f6a907" }
            : {};
        return (
          <div className={`status status_${text}`} style={style}>
            {text
              ?.replace(/_/g, " ")
              .toLowerCase()
              .replace(/^\w/, (c) => c.toUpperCase())}
          </div>
        );
      },
    },
  ];

  return (
    <div className="infinite-transfers-section">
      <div
        className="heading-div mb1"
        style={{
          width: "100%",
          display: "flex",
          justifyContent: "end",
          alignItems: "center",
          padding: "0",
        }}
      >
        {/* Left Side: Buttons */}

        {/* Right Side: Search Input */}
        <SearchInput
          placeholder="Search by Employee Name"
          handleSearch={handleSearch}
          style={{ width: "250px" }}
        />
      </div>

      {/* Toggle Buttons */}
      <div className="d-flex" style={{ justifyContent: "space-between" }}>
        <div className="mb1 d-flex gap1">
          <Button
            className={activeTab === "selected" ? "formButton" : "cancelButton"}
            onClick={() => setActiveTab("selected")}
          >
            Cards To Be Loaded (
            {/* {(() => {
              const total =
                fetchResponse?.response?.data?.total_no_of_cards ||
                fetchResponse?.total_records ||
                0;
              const calculated = total - totalDeselectedRecords;
              return calculated < 0 ? total : calculated;
            })()} */}{" "}
            {uiSelectedCount})
          </Button>
          <Button
            className={
              activeTab === "deselected" ? "formButton" : "cancelButton"
            }
            onClick={() => setActiveTab("deselected")}
          >
            Cards Not to be Loaded ({uiDeselectedCount})
          </Button>
        </div>
        <div className="d-flex gap1">
          {hasAccessToWrite && activeTab === "selected" && (
            <>
              {/* <Button
                className="formButton"
                onClick={() => setIsApproveConfirm(true)}
                disabled={
                  selectedRecords.length === 0 && deselectedRecords.length === 0
                }
              >
                Approve
              </Button> */}
              <Button
                className="formButton"
                // onClick={() => {
                //   fetchApprovalAmount({
                //     params: { bulk_upload_id: bulkId },
                //   });
                //   setIsApproveConfirm(true);
                // }}
                onClick={handleApprove}
                disabled={
                  activeTab === "selected"
                    ? selectedRecords.length === 0
                    : deselectedRecords.length === 0
                }
              >
                Approve
              </Button>

              <Button
                className="cancelButton"
                onClick={() => setIsRejectConfirm(true)}
                disabled={
                  activeTab === "selected"
                    ? selectedRecords.length === 0
                    : deselectedRecords.length === 0
                }
                loading={rejectLoad}
              >
                Reject
              </Button>
            </>
          )}
          <Button className="primary-btn" onClick={onBack}>
            Back
          </Button>
        </div>
      </div>

      {/* Selected Table (Top) */}
      {activeTab === "selected" && (
        <InfiniteTable
          id="infinite-scroll-table-top"
          columns={columns}
          data={selectedRecords}
          fetchMoreData={fetchMoreData}
          hasMore={hasMore}
          loading={loading}
          scroll={{ y: 500 }}
          className="mb2"
        />
      )}

      {/* Deselected Table (Bottom) */}
      {activeTab === "deselected" && (
        <InfiniteTable
          id="infinite-scroll-table-bottom"
          columns={columns}
          data={deselectedRecords}
          fetchMoreData={fetchMoreDeselectedData}
          hasMore={deselectedHasMore}
          loading={deselectedLoading}
          scroll={{ y: 500 }}
        />
      )}

      {/* Approve Modal */}
      <Modal
        open={isApproveConfirm}
        title="Approve Card Loading"
        onCancel={() => {
          setIsApproveConfirm(false);
          setIsApproveInitiated(false);
        }}
        footer={[]}
      >
        <p>
          Confirm Card Loading{" "}
          {(fetchResponse?.response?.data?.total_no_of_cards || 0) -
            uiDeselectedCount}{" "}
          records?
          <br />
          (Excluding {uiDeselectedCount} Cards not to be loaded)
          <br />
          {/* <strong>Total Approval Amount: Rs. {totalLoadedAmount}</strong> */}
          <strong>
            Total Approval Amount:{" "}
            {approvalAmountLoading ? "Loading..." : `Rs. ${approvalAmount}`}
          </strong>
        </p>
        <div className="d-flex mt2">
          <Button
            key="submit"
            className="formButton mr1"
            loading={approveLoad}
            onClick={handleApproveConfirm}
          >
            Confirm Approval
          </Button>
          <Button
            key="back"
            className="cancelButton"
            onClick={() => setIsApproveConfirm(false)}
          >
            Cancel
          </Button>
        </div>
      </Modal>

      {/* Reject Modal */}
      <Modal
        open={isRejectConfirm}
        title="Reject Card Loading"
        onCancel={() => {
          setIsRejectConfirm(false);
          setRejectReason("");
          setApprovalAmount(0);
        }}
        footer={[]}
      >
        <p>
          Are you sure you want to reject{" "}
          {activeTab === "selected"
            ? (() => {
                const total =
                  fetchResponse?.response?.data?.total_no_of_cards ||
                  fetchResponse?.total_records ||
                  0;
                const calculated = total - uiDeselectedCount;
                return calculated < 0 ? total : calculated;
              })()
            : deselectedRecords.length}{" "}
          records?
        </p>
        <div className="mt1">
          <Input.TextArea
            rows={4}
            placeholder="Enter reject reason (1-100 characters)"
            value={rejectReason}
            onChange={(e) => setRejectReason(e.target.value)}
            maxLength={100}
          />
        </div>
        <div className="d-flex mt2">
          <Button
            key="submit"
            className="formButton mr1"
            loading={rejectLoad}
            onClick={handleRejectConfirm}
            disabled={!rejectReason || rejectReason.length < 1}
          >
            Confirm Reject
          </Button>
          <Button
            key="back"
            className="cancelButton"
            onClick={() => {
              setIsRejectConfirm(false);
              setRejectReason("");
            }}
          >
            Cancel
          </Button>
        </div>
      </Modal>
    </div>
  );
};

export default InfiniteTransfersSection;
